import {
  DEFAULT_PAGINATION,
  type DefaultPagination,
  filterWithPaginationStates,
  type FilterWithPaginationStateShape,
  useFilterWithPaginationV2,
} from 'hooks';
import type { MeterModelsApiFilter } from 'lib/services';

export type ModelsFilter = Pick<
  MeterModelsApiFilter,
  'search' | 'manufacturerId' | 'sort' | 'technologies' | 'commodity'
>;
export type MeterModelsFilterWithPaginationShape = FilterWithPaginationStateShape<ModelsFilter>;

const STATE_KEY = 'ModelsListFilterState';

export const DEFAULT_FILTER: ModelsFilter = {
  search: undefined,
  commodity: undefined,
  manufacturerId: undefined,
  technologies: undefined,
  sort: {
    metersCount: 'desc',
  },
};

export const DEFAULT_METER_MODELS_PAGINATION: DefaultPagination = {
  ...DEFAULT_PAGINATION,
};

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: DEFAULT_METER_MODELS_PAGINATION,
});

export const useModelsListFilterWithPagination = (): MeterModelsFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
